export default 'M10.95 10.91H0C.46 5.11 5.1.5 10.95 0zm13.05.18H13V.1a12 12 0 0 1 11 11M10.95 24A12 12 0 0 1 0 13.1h10.95zM24 13.15A12 12 0 0 1 13 24V13.14z';